export default __webpack_public_path__ + "media/Differently-abled.d676910e.svg";